import { Checkbox, Tooltip } from '@mui/material';

import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columns = (): TableColumnConfig[] => [
    {
        field: 'name',
        headerName: 'Tên lịch',
        flex: 1,
        minWidth: 200,
        renderCell: (params: any) => params.row?.name || '-:-',
    },
    {
        field: 'scheduledTime',
        headerName: 'Ngày bảo trì thực tế',
        flex: 1,
        minWidth: 200,
        renderCell: (params: any) =>
            dateUtils.getDate(params.row?.scheduledTime),
    },
    {
        field: 'nextMaintenanceDate',
        headerName: 'Dự kiến bảo trì kế tiếp',
        minWidth: 200,
        flex: 1,
        renderCell: (params: any) =>
            dateUtils.getDate(params.row?.nextMaintenanceDate),
    },
    {
        field: 'assignessName',
        headerName: 'Kỹ thuật viên',
        minWidth: 200,
        flex: 1,
        renderCell: params => (
            <Tooltip title={params.row?.assignessName}>
                {params.row?.assignessName || '-:-'}
            </Tooltip>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: 'taskCheckCode',
        headerName: 'Mã Task',
        minWidth: 150,
        flex: 1,
        renderCell: params => (
            <Tooltip title={params.row?.taskCheckCode}>
                {params.row?.taskCheckCode || '-:-'}
            </Tooltip>
        ),
    },
    {
        field: 'isFilterHead',
        headerName: 'Thay lọc',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 150,
        renderCell: (params: any) => {
            return <Checkbox disabled checked={params.row.isFilterHead} />;
        },
    },
];
